import React, { useState, useEffect } from "react";
import Common_Banner from "../common/common-banner/Common_Banner";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import "./Blogs.css";
import { GetAllBlogs } from "../../features/components/blogs/blog/Slice";
import { IDS } from "../../utils/IDS";
import { useSelector, useDispatch } from "react-redux";

const Blogs = () => {
  const navigate = useNavigate();
  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.id}`, { state: blog });
  };
  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 2,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 3,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 4,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 5,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 6,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 7,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 8,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 9,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },
  ];

  const dispatch = useDispatch();
  const blog = useSelector((state) => state?.blogs?.blog?.all_blog);

  useEffect(() => {
    dispatch(GetAllBlogs());
  }, [dispatch]);

  return (
    <section className="Blogs Our_Blogs">
      <Common_Banner
        bannerImg="/assets/images/common-banner/blogs.png"
        title="Blogs"
      />
      <div className="container">
        <div className="blogs_cards_holder">
          <div className="blog_section">
            <div className="row">
              {blog?.map((post) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-6 col-12 mb-4"
                  key={post?.id}
                >
                  <div className="blog_card card">
                    <div className="card-body p-0">
                      <div className="blog_img_div ">
                        <img
                          src={IDS?.IMG_URL + post?.image}
                          alt={post?.name}
                          className="card_img"
                        />
                      </div>

                      <div className="category_title">
                        <h5 className="post_title">{post?.name}</h5>
                        <p className="post_date">
                          <span>
                            <FontAwesomeIcon
                              icon={faCalendar}
                              style={{ color: "#BFBFBF" }}
                            />
                          </span>{" "}
                          {""}
                          {new Date(post?.createdAt).toLocaleDateString(
                            "en-GB",
                            {
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            },
                          )}
                        </p>
                      </div>

                      <p className="post_desc">
                        {post?.description?.replace(/<\/?[^>]+(>|$)/g, "") ||
                          ""}
                      </p>
                    </div>

                    <div className="card-footer p-0">
                      <div className="read_more_div">
                        <button
                          className="read_more_btn"
                          onClick={() => handleBlogClick(post)}
                        >
                          Read More
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs;
